import {getAppQuickFuncListApi,getMenuPrv,addUserVisitRecord,getMenuPermissionTree} from "@/api";
import {getApi} from "@/api";
import {setLocal} from "@/utils/formExtend";
import {mapMutations} from "vuex";
export default {
    data(){
        return {
            menuListDic: {},
            menuList: [], // 确保初始化为空数组
            defaultMenuId: '',
            searchApp: '',
            senName: "",
            userAvatar: '',
            logoPhoto: "",
            chooseTenant: "", // 选择的租户 默认第一个
            chooseTenantName: "", // 选择的租户 默认第一个
            tenantList: [],
            currentTenant: [],
            appList: [],
            defaultMenuId: '',
            defaultMenuGroup: '',
            isHomeState: false
        }
    },
  methods: {
    ...mapMutations(['SET_MENUID', 'SET_MENUGROUP', 'SET_FUNLIST', 'SET_HEADERIMG', "SET_ORGINFO", "SET_APPINFO", "SET_NOICENUMBER", "SET_MENULISTDIC", "setEditableTabs"]),
    ...mapMutations(['SET_USERMANAGE', "SET_NOICENUMBER",]),
       /**
     * 切换组织信息
     * @param val  组织信息item
     */
       async changeTenant(val, callback) {
        if (val.valid === '1') {
          this.$message.error("该组织已经被禁用，请联系管理员")
          return Promise.reject(new Error('组织已禁用'))
        }
        
        try {
          sessionStorage.setItem("orgFullName", val.name)
          this.$refs.myPopover?.hide()
          
          // 换取token
          await this.changeToken(val)
          
          this.SET_ORGINFO(val)
          
          // 执行回调函数（如果提供了）
          if (typeof callback === 'function') {
            await callback()
          }
          
          return Promise.resolve()
        } catch (error) {
          console.error('切换组织失败:', error)
          return Promise.reject(error)
        }
      },
       // 换token
    changeToken(val) {
        return getApi("/exchangeForToken", {orgCode: val.orgCode}).then(res => {
          let token = res.data.token
          setLocal('token', token, 1000 * 60 * 60)
          this.isSuccess?.()
          this.getNewToken?.(val)
          this.updateNoice?.()
        })
      },
    // 获取应用快捷功能列表
    getAppQuickFuncList(id) {
      return new Promise((resolve, reject) => {
        getAppQuickFuncListApi(id)
          .then((res) => {
            this.shortcutKeyList = res.data || []
            this.SET_FUNLIST(res.data || [])
            resolve(res.data)
          })
          .catch(reject)
      })
    },

    // 处理应用选择
    async isApp(row) {
      if (row.valid === '1') {
        this.$message.warning("该应用已禁用，请联系管理员")
        return false
      }

      // 设置应用信息
      sessionStorage.setItem('appid', row.appId)
      sessionStorage.setItem('appRow', JSON.stringify(row))
      this.SET_APPINFO(row)

      // 设置主题
      sessionStorage.setItem("topic", JSON.stringify(row.topic))

      // 获取应用快捷功能
      await this.getAppQuickFuncList(row.appId)

      try {
        // 获取应用按钮权限
        const resPermission = await getMenuPermissionTree(row.appId)
        sessionStorage.setItem('routerListPermission', JSON.stringify(resPermission.data))

        const res = await getMenuPrv(row.appId)
        if (!res.data) {
          this.$message.warning("暂时查询不到相关菜单")
          return false
        }

        this.SET_APPINFO(row)
        this.handleMenuListDic?.(res.data)
        
        // 处理菜单数据
        const data = this.addLevelAndParentPath(res.data)
        this.menuList = this.addLevelAndParentPath(data)

        // 计算路由白名单
        const whiteMenu = this.extractPaths(res.data)
        sessionStorage.setItem('whiteMenu', JSON.stringify(whiteMenu))
        sessionStorage.setItem('routerList', JSON.stringify(data))
        // 获取第一个菜单路径
        const first = this.findFirstPath(data)
        const to = first.path
        this.getActiveId(data, to)
        sessionStorage.setItem("defaultMenuId", this.defaultMenuId)

        // 添加访问记录
        const params = {
          appId: row.appId,
          modelId: row.modelId,
          url: to,
          orgCode: this.currentTenant.orgCode
        }
        console.log(this.currentTenant)
        await addUserVisitRecord(params)

        // 设置标签页
        const editableTabs = [{
          title: first.name,
          name: first.path,
          content: first.name,
        }]
        this.setEditableTabs(editableTabs)

        // 路由跳转
        await this.$router.push(to)

        // 设置默认菜单
        if (this.$router.currentRoute.value.fullPath === '/') {
          const defaultMenu = this.menuList[0].children 
            ? this.menuList[0].children[0]
            : this.menuList[0]
          sessionStorage.setItem('menuList', JSON.stringify(defaultMenu))
          localStorage.setItem('menuList', JSON.stringify(defaultMenu))
        }

        this.$forceUpdate()
        return true
      } catch (error) {
        console.error('处理菜单数据时出错:', error)
        return false
      }
    },

  // 使用这个函数并传入树的根节点
  
  findPath(node) {
    // 如果当前节点有效且包含路径，返回这个路径
    if (node.valid === "0" && node.path) {
      return node;
    }
    // 如果有子节点，递归检查子节点
    if (node.children && node.children.length > 0) {
      for (let i = 0; i < node.children.length; i++) {
        let result = this.findPath(node.children[i]);
        // 如果子节点中有路径，返回这个路径
        if (result) {
          return result;
        }
      }
    }
    // 如果当前节点无效或者没有子节点，返回undefined
    return undefined;
  },
  addLevelAndParentPath(items, parentPath = '') {
    return items.map((item) => {
      let newItem = {...item}; // 深拷贝
      newItem.parentPath = parentPath; // 设置上级路径
      if (parentPath === '') { // 如果上级路径是第一层，则不添加 /
        newItem.parentPath = item.name;
        // newItem.level = 0; // 计算层级
      } else {
        newItem.parentPath = `${parentPath}/${item.name}`;
      }
      newItem.level = newItem.parentPath.split('/').length - 1; // 计算层级
      if (item.children && item.children.length > 0) {
        newItem.children = this.addLevelAndParentPath(item.children, newItem.parentPath);
      }
      return newItem;
    });
  },

  extractPaths(menuItems, paths = []) {
    menuItems.forEach(item => {
      if (item.path) {
        paths.push(item.path);
      }
      if (item.children) {
        this.extractPaths(item.children, paths);
      }
    });
    return paths;
  },

    // 查找第一个路径
    findFirstPath(data) {
        // 遍历数据数组
        for (let i = 0; i < data.length; i++) {
          let result = this.findPath(data[i]);
          // 如果找到了路径，返回它
          if (result) {
            sessionStorage.setItem("menuList", JSON.stringify(data[i]))
            return result;
          }
        }
        // 如果没有找到任何路径，返回undefined
        return undefined;
      },

     // 获取当前菜单的默认activeId
     getActiveId(data, to) {
        // 获取当前的菜单id
        let pathname = to
        this.defaultMenuId = findMenuIndex(data, pathname);
  
        function findMenuIndex(menuList, targetPath, parentIndex = '') {
          for (let i = 0; i < menuList.length; i++) {
            const menu = menuList[i];
            if (menu.path === targetPath) {
              return parentIndex === '' ? i.toString() : parentIndex + '-' + i;
            } else if (menu.children) {
              const index = findMenuIndex(menu.children, targetPath, parentIndex === '' ? i.toString() : parentIndex + '-' + i);
              if (index) {
                return index;
              }
            }
          }
          return null;
        }
      },
  // 处理menuList
  handleMenuListDic(data) {
    this.menuListDic = this.parseMenu(data)
    this.SET_MENULISTDIC(this.menuListDic)
  },
  parseMenu(data) {
    const result = {};

    function traverse(menuList, parentPath) {
      for (const item of menuList) {
        const path = item.path;
        if (path) {
          const [key, ...value] = path.split('/').filter(Boolean);
          if (!result[key]) {
            result[key] = [];
          }
          result[key].push('/' + value.join('/'));
        }

        if (item.children) {
          traverse(item.children, path);
        }
      }
    }

    traverse(data, '');

    return result;
  },
  }
}
